import type {
  AccountDeactivate,
  MessageResponse,
  PaginatedUsers,
  PasswordChange,
  User,
  UserCreate,
  UserListParams,
  UserRoleUpdate,
  UserStatusUpdate,
  UserUpdate,
} from '../types';
import apiClient from './apiClient';

export const userService = {
  async getMe(): Promise<User> {
    const response = await apiClient.get<User>('/users/me');
    return response.data;
  },

  async updateMe(data: UserUpdate): Promise<User> {
    const response = await apiClient.patch<User>('/users/me', data);
    return response.data;
  },

  async changePassword(data: PasswordChange): Promise<MessageResponse> {
    const response = await apiClient.post<MessageResponse>(
      '/users/me/change-password',
      data
    );
    return response.data;
  },

  async deactivateAccount(data: AccountDeactivate): Promise<MessageResponse> {
    const response = await apiClient.delete<MessageResponse>('/users/me', {
      data,
    });
    return response.data;
  },

  async listUsers(params: UserListParams = {}): Promise<PaginatedUsers> {
    const response = await apiClient.get<PaginatedUsers>('/users', { params });
    return response.data;
  },

  async getUser(userId: string): Promise<User> {
    const response = await apiClient.get<User>(`/users/${userId}`);
    return response.data;
  },

  async updateUserRole(userId: string, data: UserRoleUpdate): Promise<User> {
    const response = await apiClient.patch<User>(`/users/${userId}/role`, data);
    return response.data;
  },

  async updateUserStatus(userId: string, data: UserStatusUpdate): Promise<User> {
    const response = await apiClient.patch<User>(`/users/${userId}/status`, data);
    return response.data;
  },

  async createUser(data: UserCreate): Promise<User> {
    const response = await apiClient.post<User>('/users', data);
    return response.data;
  },
};
